import { Middleware } from "@reduxjs/toolkit"
import { RootState } from "../rootReducer"
import { DIALOG_DRAFTS_STORAGE_KEY } from "./constants"
import { upsertDraft, removeDraft, clearDrafts } from "./slice"

const DRAFT_ACTIONS = new Set([upsertDraft.type, removeDraft.type, clearDrafts.type])

export const persistDialogDraftsMiddleware: Middleware<unknown, RootState> = store => next => action => {
    const result = next(action)

    if (DRAFT_ACTIONS.has(action.type)) {
        const { dialogDrafts } = store.getState()
        const draftsArray = Object.values(dialogDrafts.entities).filter(Boolean)
        localStorage.setItem(DIALOG_DRAFTS_STORAGE_KEY, JSON.stringify(draftsArray))
    }

    return result
}
